let isMobileJS = window.isMobile;
if (!isMobileJS) throw new Error('isMobile.js is not found');

let landscape = true;

if (window.screen.hasOwnProperty("orientation") && window.screen.orientation.hasOwnProperty("type") && window.screen.orientation.type.indexOf('portrait') !== -1) {
    landscape = false;
}

export const initialState = {
    desktop: !isMobileJS.any,
    mobile: isMobileJS.any,
    phone: isMobileJS.phone,
    tablet: isMobileJS.tablet,
    landscape: landscape
};

function onWindowOrientationChange(event, store) {
    let landscape = false;
    if (window.screen.hasOwnProperty("orientation") && window.screen.orientation.hasOwnProperty("angle") && window.screen.orientation.angle != null) {
        let angle = window.screen.orientation.angle;
        if (angle === 0 || angle === 180) landscape = false;
        if (angle === 90 || angle === 270) landscape = true;
    }

    store.dispatch({type: 'ORIENTATION_CHANGE', landscape});
}

export function reduxBind(store) {
    window.addEventListener('orientationchange', function(event) { onWindowOrientationChange(event, store) });
}


// WEBPACK FOOTER //
// ./src/bindings/browser-redux.js